import React from "react";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
import storefrontImg from "../../assets/city-hardware-outside.png";
import drinksImg from "../../assets/city-hardware-detroit-drinks.png";
import "./StoreInfo.css";

function StoreInfo() {
  return (
    <section className="store-info">
      <div className="container store-info__inner">
        {/* Left: photos stacked */}
        <div className="store-info__photos">
          <div className="store-info__photo-main-wrap">
            <img
              src={storefrontImg}
              alt="City Hardware storefront exterior on a sunny Detroit day"
              className="store-info__photo-main"
            />
            <div className="store-info__photo-badge">
              Open Mon-Sat, Closd Sunday
            </div>
          </div>
          <div className="store-info__photo-accent-wrap">
            <img
              src={drinksImg}
              alt="City Hardware — cold drinks available in store"
              className="store-info__photo-accent"
            />
            <div className="store-info__photo-accent-label">
              Stop in &amp; stay a while
            </div>
          </div>
        </div>

        {/* Right: details */}
        <div className="store-info__details">
          <div className="store-info__eyebrow">Find Us</div>
          <h2 className="store-info__heading">
            Detroit's
            <br />
            Local Hardware Store
          </h2>
          <p className="store-info__tagline">
            "From quick fixes to bigger projects, City Hardware has you
            covered."
          </p>

          <div className="store-info__list">
            <div className="store-info__item">
              <MapPin size={18} className="store-info__icon" />
              <div>
                <div className="store-info__item-label">Address</div>
                <a
                  href="https://maps.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-info__item-value store-info__item-value--link">
                  16325 W Warren Ave, Detroit, MI 48228
                </a>
              </div>
            </div>

            <div className="store-info__item">
              <Clock size={18} className="store-info__icon" />
              <div>
                <div className="store-info__item-label">Hours</div>
                <div className="store-info__item-value">
                  Mon–Friday 9:00 AM – 6:00 PM
                </div>
                <div className="store-info__item-value">
                  Saturday 9:00 AM – 5:00 PM
                </div>
                <div className="store-info__item-value">Closed Sunday</div>
              </div>
            </div>

            <div className="store-info__item">
              <Phone size={18} className="store-info__icon" />
              <div>
                <div className="store-info__item-label">Phone</div>
                <a
                  href="tel:+13135828860"
                  className="store-info__item-value store-info__item-value--link">
                  (313) 582-8860
                </a>
              </div>
            </div>

            <div className="store-info__item">
              <Mail size={18} className="store-info__icon" />
              <div>
                <div className="store-info__item-label">Email</div>
                <a
                  href="mailto:hello@cityhardware.com"
                  className="store-info__item-value store-info__item-value--link">
                  hello@cityhardware.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default StoreInfo;
